<div class="card h-full">
  <div class="card-header">
    <h2 class="text-xl font-semibold">Opérations de maintenance</h2>
    <button
      *ind4HasRole="'SED_PLUS_REGULAR_USER'"
      type="button"
      pButton
      pRipple
      icon="pi pi-pencil"
      class="p-button-sm p-button-outlined"
      pTooltip="Modifier les opérations de maintenance"
      (click)="openEditModal()"
    >
      Modifier
    </button>
  </div>

  <app-data-state [loading]="loading$ | async" [error]="error$ | async">
    <div class="p-fluid">
      <div class="flex flex-col gap-1">
        <ng-template #noData>
          <app-no-data></app-no-data>
        </ng-template>

        <ul
          *ngIf="sortedOperationsMaintenance?.length; else noData"
          class="alert-list"
        >
          <li
            *ngFor="let operationMaintenance of sortedOperationsMaintenance"
            class="maintenance-item"
          >
            <div class="action-icon action-calendar-days">
              <i-lucide name="calendar-days" [size]="16"></i-lucide>
            </div>
            <div>
              <div style="font-weight: 500">
                {{ operationMaintenance?.description }}
              </div>
              <div
                class="capitalize"
                class="text-[13px] text-gray-600 dark:text-gray-300"
              >
                Périodicité : {{ operationMaintenance?.periodicity }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </app-data-state>

  <!-- Edit Modal -->
  <app-edit-operations-maintenance-modal
    [visible]="showEditModal"
    [items]="operationsMaintenance ?? []"
    [ruleUid]="ruleUid ?? ''"
    (visibleChange)="showEditModal = $event"
    (onSubmitForm)="onModalSubmit($event)"
    (onCancelForm)="onModalCancel()"
  ></app-edit-operations-maintenance-modal>
</div>
